import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa"; // Hoặc bất kỳ icon nào bạn muốn

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Kiểm tra khi người dùng cuộn xuống để hiển thị nút
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        // Hiển thị nút khi cuộn xuống 200px
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    isVisible && (
      <button
        onClick={scrollToTop}
        className="fixed bottom-32 right-4 lg:right-24 bg-white/80 text-black p-3 rounded-lg shadow-lg transition transform hover:scale-105 flex items-center space-x-2 z-50"
        title="Lên đầu trang"
      >
        <div className="flex flex-col justify-items-center items-center">
          <FaArrowUp size={20} />
        </div>
      </button>
    )
  );
};

export default ScrollToTopButton;
